import constants from './revaConstants';

export default {
    setRevaMe: (payload) => ({
        type: constants.SET_REVA_ME,
        payload
    }),
    setRevaLineups: (payload) => ({
        type: constants.SET_REVA_LINEUPS,
        payload
    }),
    setRevaPlayers: (payload) => ({
        type: constants.SET_REVA_PLAYERS,
        payload
    }),
    setRevaAccounts: (payload) => ({
        type: constants.SET_REVA_ACCOUNTS,
        payload
    }),
    setRevaLineupFinancials: (payload) => ({
        type: constants.SET_REVA_LINEUP_FINANCIALS,
        payload
    }),
    setRevaPlayerFinancials: (payload) => ({
        type: constants.SET_REVA_PLAYER_FINANCIALS,
        payload
    }),
    setRevaPriceList: (payload) => ({
        type: constants.SET_REVA_PRICE_LIST,
        payload
    }),
    updateRevaLineup: (payload) => ({
        type: constants.UPDATE_REVA_LINEUP,
        payload
    }),
    setRevaDebtSummary: (payload) => ({
        type: constants.SET_REVA_DEBT_SUMMARY,
        payload
    }),
    setRevaLineupInvoices: (payload) => ({
        type: constants.SET_REVA_LINEUP_INVOICES,
        payload
    }),
    setRevaPlayerInvoices: (payload) => ({
        type: constants.SET_REVA_PLAYER_INVOICES,
        payload
    }),
    setRevaSiloBalances: (payload) => ({
        type: constants.SET_REVA_SILO_BALANCES,
        payload
    }),
    setRevaLineupSiloBalances: (payload) => ({ type: constants.SET_REVA_LINEUP_SILO_BALANCES, payload }),
    setRevaIncomeSummary: (payload) => ({ type: constants.SET_REVA_INCOME_SUMMARY, payload }),
    setRevaTransactionsSummary: (payload) => ({ type: constants.SET_REVA_TRANSACTIONS_SUMMARY, payload }),
    setRevaConnectionError: (payload) => ({ type: constants.SET_REVA_CONNECTION_ERROR, payload }),
    clearRevaState: () => ({ type: constants.CLEAR_REVA_STATE }),
};
